import { Breakpoints, styled } from "@vw-marketing/us-components";
interface StyledStickyHeaderProps {
  active: boolean;
  stickyPosition?: number;
  noPadding?: boolean;
  activeModal?: boolean;
  bottomShadow?: boolean;
  width?: number;
}
export const StyledPositionWrapper: any = styled.div<StyledStickyHeaderProps>`
  padding: 0 16px;

  @media (min-width: ${Breakpoints.b560}px) {
    padding: 0;
  }
`;

export const StyledStickyHeader: any = styled.div<StyledStickyHeaderProps>`
  ${({ active, activeModal, width }: any) => {
    const isMobile = width < Breakpoints.b560;
    const isTablet = width >= Breakpoints.b560 && width < 950;
    const isTablet2 = width >= 950 && width < 1050;
    const isTablet3 = width >= 1050;

    let offset = 0;
    if (isMobile) offset = -2;
    else if (isTablet) offset = -7;
    else if (isTablet2) offset = -15;
    else if (isTablet3) offset = -17;

    const lineHeight = "24px";

    return `

    padding: 0;

    &.down {
      @media (min-width: ${Breakpoints.default}px) {
        --sticky-bar-height-down: calc(16px + ${lineHeight} + 12px + 0px);
        --sticky-bar-height-up: calc(16px + ${lineHeight} + 12px + 32px);
      }
      @media (min-width: ${Breakpoints.b560}px) {
        --sticky-bar-height-up: calc(16px + ${lineHeight} + 12px + 40px);
      }
      @media (min-width: ${Breakpoints.b960}px) {
        --sticky-bar-height-up: calc(16px + ${lineHeight} + 12px + 48px);
      }
      @media (min-width: ${Breakpoints.b1920}px) {
        --sticky-bar-height-down: calc(24px + ${lineHeight} + 12px + 0px);
        --sticky-bar-height-up: calc(24px + ${lineHeight} + 12px + 56px);
      }
    }
    &.up {
      @media (min-width: ${Breakpoints.default}px) {
        --sticky-bar-height-up: calc(16px + ${lineHeight} + 12px + 32px);
        --sticky-bar-height-down: calc(16px + ${lineHeight} + 12px + 0px);
      }
      @media (min-width: ${Breakpoints.b560}px) {
        --sticky-bar-height-up: calc(16px + ${lineHeight} + 12px + 40px);
      }
      @media (min-width: ${Breakpoints.b960}px) {
        --sticky-bar-height-up: calc(16px + ${lineHeight} + 12px + 48px);
      }
      @media (min-width: ${Breakpoints.b1920}px) {
        --sticky-bar-height-up: calc(24px + ${lineHeight} + 12px + 56px);
      }
    }
      ${
        !active && !activeModal
          ? `transition: transform 0.3s ease-in;
        background-color: white;
        transform: translateY(0px);
        @keyframes fadeUp {
          from {margin-top:var(--sticky-bar-height-down) ;}
          to {margin-top:var(--sticky-bar-height-up);}
        }
        @keyframes fadeDown {
          from {margin-top:var(--sticky-bar-height-up) ;}
          to {margin-top:var(--sticky-bar-height-down);}
        }
        ${
          !activeModal
            ? `
            &.down {
              margin-top: var(--sticky-bar-height-down);
              -webkit-animation: fadeDown  0.4s ease-in 0s;
              -moz-animation: fadeDown  0.4s ease-in 0s;
              animation: fadeDown  0.4s ease-in 0s;
            }
            &.up {
              margin-top: var(--sticky-bar-height-up);
              -webkit-animation: fadeUp  0.3s ease-in 0s;
              -moz-animation: fadeUp 0.3s ease-in 0s;
              animation: fadeUp  0.3s ease-in 0s ;
            }
          `
            : ""
        }
  `
          : `
          width: 100%;
          margin-top: 16px;
        `
      }
      @media (min-width: ${Breakpoints.b560}px) {
        ${
          !active
            ? `transition: transform 0.3s ease-in;
          background-color: white;
          transform: translateY(0px);
          @keyframes fadeUp {
            from {margin-top:var(--sticky-bar-height-down) ;}
            to {margin-top:var(--sticky-bar-height-up);}
          }
          @keyframes fadeDown {
            from {margin-top:var(--sticky-bar-height-up) ;}
            to {margin-top:var(--sticky-bar-height-down);}
          }

          &.down {
            margin-top: var(--sticky-bar-height-down);
            -webkit-animation: fadeDown  0.4s ease-in 0s;
            -moz-animation: fadeDown  0.4s ease-in 0s;
            animation: fadeDown  0.4s ease-in 0s;
          }
          &.up {
            margin-top: var(--sticky-bar-height-up);
            -webkit-animation: fadeUp  0.3s ease-in 0s;
            -moz-animation: fadeUp 0.3s ease-in 0s;
            animation: fadeUp  0.3s ease-in 0s ;
          }
    `
            : `
            width: 100%;
            margin-top: 16px;
            `
        }
      }
`;
  }}
`;

export const StyledStickyHeaderContainer = styled.div<StyledStickyHeaderProps>`
  ${({ active, activeModal, bottomShadow }: any) => {
    return `
    ${
      !active && !activeModal
        ? `
          position: fixed;
          z-index: ${activeModal ? "2" : "1"};
          width: 100%;
          top: 0;
          background-color: white;
          transform: translateY(0px);
          opacity: 1;

          box-shadow: ${
            bottomShadow ? "0 4px 28px -6px rgba(106, 118, 125, 0.5)" : "none"
          };

          @media (max-width: ${Breakpoints.b960}px) {
            z-index: ${activeModal ? "2" : "1"};
          }

          @media (min-width: ${Breakpoints.b1280}px) {
            z-index:  ${activeModal ? "2" : "1"};
          }
        `
        : `
          width: 100%;
        `
    }
    `;
  }}
`;
